var i18n = require("react-i18next");

exports.getLang = function () {
  return i18n.getI18n().language;
};
